import {
  FindListingsResponse,
  OpResponseCode,
  PropertyTypeID,
} from '@klokhuis/core/ApiClient/Klokhuis';

import mockListingImage from './mockListingImage.jpeg';

export const mockListingCountResponse = {
  total: 34452,
  OpResponse: {
    Code: OpResponseCode.OPERATION_SUCCESSFUL,
    Message: 'Operation successful.',
    HttpStatusCode: 200,
  },
  LogEntryId: null,
};

export const mockGetLocationsResponse = {
  locations: [{ cityName: 'Tenkasi', name: 'Tenkasi, Tirunelveli' }],
  LogEntryId: 12345,
  OpResponse: {
    Code: OpResponseCode.OPERATION_SUCCESSFUL,
    HttpStatusCode: 200,
  },
};

export const mockListingsState = {
  listingsState: {
    filterResult: {
      count: 0,
      filters: {},
    },
    listingsResult: {
      isLoading: false,
      listings: {},
    },
  },
  dispatch: () => {},
};

export const mockFindListingsResponse: FindListingsResponse = {
  listings: [
    {
      listingId: 123451,
      thumbnailUrl: mockListingImage.src,
      cityName: 'Example City 1',
      plotArea: 100,
      listingTypeId: PropertyTypeID.CommercialLand,
      salePrice: 5000000,
      plotAreaUnit: '',
      isActive: false,
      sellerId: 1,
      citySlugId: 3,
      citySlug: 'chennai-tamil-nadu',
      areaOrLandmark: 'Near Central Park',
      listingStatus: 'Available' as any,
    },
    {
      listingId: 123452,
      thumbnailUrl: mockListingImage.src,
      cityName: 'Example City 2',
      plotArea: 100,
      listingTypeId: PropertyTypeID.ResidentialLand,
      salePrice: 5000000,
      plotAreaUnit: '',
      isActive: false,
      sellerId: 1,
      citySlugId: 3,
      citySlug: 'chennai-tamil-nadu',
      areaOrLandmark: 'Opposite City Mall',
      listingStatus: 'Available' as any,
    },
    {
      listingId: 123453,
      thumbnailUrl: mockListingImage.src,
      cityName: 'Example City 3',
      plotArea: 200,
      listingTypeId: PropertyTypeID.FarmLand,
      salePrice: 7500000,
      plotAreaUnit: 'sqft',
      isActive: true,
      sellerId: 2,
      citySlugId: 6,
      citySlug: 'bangalore-karnataka',
      areaOrLandmark: 'Close to River Side',
      listingStatus: 'Available' as any,
    },
    {
      listingId: 123454,
      thumbnailUrl: mockListingImage.src,
      cityName: 'Example City 4',
      plotArea: 120,
      listingTypeId: PropertyTypeID.HouseOrVilla,
      salePrice: 12000000,
      plotAreaUnit: 'sqft',
      isActive: true,
      sellerId: 3,
      citySlugId: 7,
      citySlug: 'hyderabad-telangana',
      areaOrLandmark: 'Next to City Hospital',
      listingStatus: 'Available' as any,
    },
  ],
  nearbyListings: [
    {
      listingId: 223451,
      thumbnailUrl: mockListingImage.src,
      cityName: 'Nearby City',
      plotArea: 80,
      listingTypeId: PropertyTypeID.CommercialLand,
      salePrice: 3000000,
      plotAreaUnit: '',
      isActive: true,
      sellerId: 2,
      citySlugId: 4,
      citySlug: 'nearby-city-tamil-nadu',
      areaOrLandmark: 'Near Old Market',
      listingStatus: 'Available' as any,
    },
    {
      listingId: 223452,
      thumbnailUrl: mockListingImage.src,
      cityName: 'Nearby City 2',
      plotArea: 90,
      listingTypeId: PropertyTypeID.ResidentialLand,
      salePrice: 3500000,
      plotAreaUnit: 'sqft',
      isActive: false,
      sellerId: 4,
      citySlugId: 8,
      citySlug: 'nearby-city2-tamil-nadu',
      areaOrLandmark: 'Close to City Library',
      listingStatus: 'Available' as any,
    },
  ],
  topAdListings: [
    {
      listingId: 323451,
      thumbnailUrl: mockListingImage.src,
      cityName: 'TopAd City',
      plotArea: 150,
      listingTypeId: PropertyTypeID.CommercialLand,
      salePrice: 8000000,
      plotAreaUnit: '',
      isActive: true,
      sellerId: 3,
      citySlugId: 5,
      citySlug: 'topad-city-tamil-nadu',
      areaOrLandmark: 'Opposite Tech Park',
      listingStatus: 'Available' as any,
    },
    {
      listingId: 323452,
      thumbnailUrl: mockListingImage.src,
      cityName: 'TopAd City 2',
      plotArea: 180,
      listingTypeId: PropertyTypeID.FarmLand,
      salePrice: 9500000,
      plotAreaUnit: 'sqft',
      isActive: false,
      sellerId: 5,
      citySlugId: 9,
      citySlug: 'topad-city2-tamil-nadu',
      areaOrLandmark: 'Adjacent to Green Fields',
      listingStatus: 'Available' as any,
    },
  ],
  total: 8,
  LogEntryId: 12345,
  OpResponse: {
    Code: OpResponseCode.OPERATION_SUCCESSFUL,
    HttpStatusCode: 200,
  },
};
